/* Nouveau challenge — TC-01 (Bible v3.2.2 §7 · L10).
   Team goal is the default: the same staff behaviour — remembering to offer
   the card — without pitting colleagues against each other or creating
   attribution disputes. Individual mode is opt-in, and only unlocks once the
   French employee notice is confirmed as delivered. Attribution is fixed at
   source: a tracked QR is a personal card the staff member hands over, not
   the till Display. */
import { useState } from 'react'
import { Button, Card, ErrorState, Field, Input, KV, ListRow, Note } from '@/ui'
import { useChallenge, type ChallengeMode } from './api'
import { Chargement, Retour } from './parts'

export default function Nouveau() {
  const { data, isPending, isError, refetch } = useChallenge()
  const [mode, setMode] = useState<ChallengeMode>('equipe')

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger le défi."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const d = data
  const choix = (m: ChallengeMode) => (
    <input type="radio" name="mode" className="chk" style={{ borderRadius: '50%' }}
      checked={mode === m} onChange={() => setMode(m)}
      aria-label={m === 'equipe' ? 'Objectif d’équipe' : 'Contributions individuelles'} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 720 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Nouveau challenge</h2>

      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: '1fr 1fr' }}>
        <Field label="Nom">{id => <Input id={id} defaultValue={d.name} />}</Field>
        <Field label="Période">{id => <Input id={id} defaultValue={d.period} />}</Field>
      </div>

      <div>
        <span className="f-label">Mode</span>
        <ListRow
          title="Objectif d’équipe"
          meta={<>Un objectif partagé, une progression collective. Aucun chiffre individuel visible. <b>Recommandé.</b></>}
          end={choix('equipe')} />
        <ListRow
          title="Contributions individuelles"
          meta="Cartes QR personnelles. Le responsable voit les contributions ; chacun ne voit que les siennes."
          end={choix('individuel')} />
      </div>

      <Card>
        <KV rows={[
          ['Objectif du mois', <span key="o"><b>{d.goal} participations</b> · {d.scope}</span>],
          ['Mesure', <span key="m"><b>invitations proposées</b> — jamais les avis reçus ni la qualité du service</span>],
          ['Reconnaissance', <span key="r">badge + prime gérée par vous — <b>hors</b> cadeaux clients et stock campagne</span>],
        ]} />
      </Card>

      <Note tone="candour">
        Le mode <b>Contributions individuelles</b> ne s’active qu’après confirmation que la
        notice employé française a été remise (objectif, mesure, visibilité, rétention,
        équité, voie de contestation).
      </Note>
    </div>
  )
}
